export default function unMaskAll(props: string): string {
    const value = props
        .replace(/[^\d]+/gi, '')
        .split('')
        .join('')
    return value
}
